import { actionTypes } from '../actions/actionTypes/ServiceBillingActionTypes';

let initialState = {
  ServiceBillingList: [],
  getServiceBillingLoader: false,
  ServiceBillingData: {},
  viewInvoiceLoader: false,
  skipEmailProcessLoader: false,
  proceedToSendEmailLoader: false,
  saveInvoiceDetailsLoader: false,
  individualSendEmailLoader: false,
  sendBackToInvoiceGenerateLoader: false,
  updatedReceiptDataLoader: false,
  writtenOffLoader: false,
  sendBackToPMLoader: false,
  auditHistory: [],
  auditHistoryLoader: false,
  pendingUpdateInvoicePyID: null,
};

// postServiceBilling is one generic thunk shared by every Pega actionType, so
// success/failure carries back which actionType it was for (see
// ServiceBillingActions.js) and this maps that to the one loader flag to
// clear — mirroring how e.g. OPEN_PM_CASE_SUCCESS/FAILURE only ever clears
// openPMCaseLoader, not every loader in the module.
const LOADER_FLAG_BY_ACTION_TYPE = {
  ViewInvoice: 'viewInvoiceLoader',
  SkipEmailProcess: 'skipEmailProcessLoader',
  ProceedToSendEmail: 'proceedToSendEmailLoader',
  SaveInvoiceDetails: 'saveInvoiceDetailsLoader',
  IndividualSendEmail: 'individualSendEmailLoader',
  SendBackTOInvoiceGenerate: 'sendBackToInvoiceGenerateLoader',
  UpdatedReceiptData: 'updatedReceiptDataLoader',
  WrittenOff: 'writtenOffLoader',
  SendBackTOPM: 'sendBackToPMLoader',
};

export function serviceBilling(state = initialState, action) {
  switch (action.type) {
    case actionTypes.GET_SERVICE_BILLING_SUCCESS:
      return {
        ...state,
        ServiceBillingList: action?.cases || [],
        getServiceBillingLoader: false,
      };
    case actionTypes.GET_SERVICE_BILLING_FAILURE:
      return {
        ...state,
        ServiceBillingList: [],
        getServiceBillingLoader: false,
      };
    case actionTypes.GET_SERVICE_BILLING_LOADER:
      return {
        ...state,
        getServiceBillingLoader: true,
      };

    case actionTypes.POST_SERVICE_BILLING_SUCCESS: {
      const loaderFlag = LOADER_FLAG_BY_ACTION_TYPE[action.actionType];
      return {
        ...state,
        ServiceBillingData: action?.cases || {},
        ...(loaderFlag && { [loaderFlag]: false }),
      };
    }
    case actionTypes.POST_SERVICE_BILLING_FAILURE: {
      const loaderFlag = LOADER_FLAG_BY_ACTION_TYPE[action.actionType];
      return {
        ...state,
        ServiceBillingData: {},
        ...(loaderFlag && { [loaderFlag]: false }),
      };
    }

    case actionTypes.VIEW_INVOICE_LOADER:
      return { ...state, viewInvoiceLoader: true };
    case actionTypes.SKIP_EMAIL_PROCESS_LOADER:
      return { ...state, skipEmailProcessLoader: true };
    case actionTypes.PROCEED_TO_SEND_EMAIL_LOADER:
      return { ...state, proceedToSendEmailLoader: true };
    case actionTypes.SAVE_INVOICE_DETAILS_LOADER:
      return { ...state, saveInvoiceDetailsLoader: true };
    case actionTypes.INDIVIDUAL_SEND_EMAIL_LOADER:
      return { ...state, individualSendEmailLoader: true };
    case actionTypes.SEND_BACK_TO_INVOICE_GENERATE_LOADER:
      return { ...state, sendBackToInvoiceGenerateLoader: true };
    case actionTypes.UPDATED_RECEIPT_DATA_LOADER:
      return { ...state, updatedReceiptDataLoader: true };
    case actionTypes.WRITTEN_OFF_LOADER:
      return { ...state, writtenOffLoader: true };
    case actionTypes.SEND_BACK_TO_PM_LOADER:
      return { ...state, sendBackToPMLoader: true };

    case actionTypes.GET_SERVICE_BILLING_AUDIT_HISTORY_SUCCESS:
      return {
        ...state,
        auditHistory: action.cases?.ProjectInfo?.InvoiceHistory || [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_SERVICE_BILLING_AUDIT_HISTORY_FAILURE:
      return {
        ...state,
        auditHistory: [],
        auditHistoryLoader: false,
      };
    case actionTypes.GET_SERVICE_BILLING_AUDIT_HISTORY_LOADER:
      return {
        ...state,
        auditHistoryLoader: true,
      };
    case actionTypes.SET_PENDING_UPDATE_INVOICE:
      return { ...state, pendingUpdateInvoicePyID: action.pyID };

    default:
      return state;
  }
}
